export const normalizeRuleRows = (response) => {
  const source = response && typeof response === "object" && !Array.isArray(response) ? response : {};
  const rows = Array.isArray(source.rules) ? source.rules : Array.isArray(source.data) ? source.data : [];
  const grouped = {};
  rows.forEach((row) => {
    const serviceId = Number(row && row.service_id);
    const otherId = Number(row && row.incompatible_service_id);
    if (!Number.isInteger(serviceId) || !Number.isInteger(otherId) || serviceId === otherId) return;
    if (!grouped[serviceId]) grouped[serviceId] = [];
    if (!grouped[serviceId].includes(otherId)) grouped[serviceId].push(otherId);
  });
  return grouped;
};

export const buildIncompatibleIds = (values) => {
  const ids = [];
  (Array.isArray(values) ? values : []).forEach((value) => {
    const parsed = Number(value);
    if (!Number.isInteger(parsed) || parsed <= 0) return;
    if (!ids.includes(parsed)) ids.push(parsed);
  });
  return ids.sort((left, right) => left - right);
};

export const toggleIncompatibleId = (current, serviceId) => {
  const parsed = Number(serviceId);
  const existing = buildIncompatibleIds(current);
  if (!Number.isInteger(parsed) || parsed <= 0) return existing;
  return existing.includes(parsed)
    ? existing.filter((id) => id !== parsed)
    : buildIncompatibleIds([...existing, parsed]);
};

export const normalizeServiceOptions = (response) => {
  const rows = Array.isArray(response)
    ? response
    : response && Array.isArray(response.data)
      ? response.data
      : [];
  const seen = new Set();
  const options = [];
  rows.forEach((row) => {
    const id = Number(row && row.id);
    if (!Number.isInteger(id) || id <= 0 || seen.has(id)) return;
    seen.add(id);
    const name = row && (row.name || row.label);
    options.push({ id, name: name ? String(name) : `Service ${id}` });
  });
  return options.sort((left, right) => left.id - right.id);
};

export const incompatibilitySavePayload = (service, incompatibleServiceIds) => {
  const serviceId = Number(service && service.id);
  return {
    service_id: Number.isInteger(serviceId) && serviceId > 0 ? serviceId : null,
    incompatible_service_ids: buildIncompatibleIds(incompatibleServiceIds),
  };
};
